type AnyObject = Record<string, any>

export default function localize(input: any): any {
  // Case 1: array → elk item recursief transformeren
  if (Array.isArray(input)) {
    return input.map(localize)
  }

  // Case 2: object
  if (input !== null && typeof input === 'object') {
    // Als localizations bestaat en array is
    if (
      'localizations' in input
      && Array.isArray(input.localizations)
      && input.localizations.find((localization: any) => localization.locale === 'en-BE')
    ) {
      return localize(input.localizations.find((localization: any) => localization.locale === 'en-BE'))
    }

    // Anders: loop alle keys af
    const result: AnyObject = {}
    for (const key of Object.keys(input)) {
      result[key] = localize(input[key])
    }
    return result
  }

  // Case 3: primitive (string, number, etc.)
  return input
}
